import React from 'react'
import{
  Button,
  Stack,
} from '@chakra-ui/core'

const MainDashboardMenu = ({ currentSection, setCurrentSection }) => {
  return (
    <Stack pt="2"  display={["none", "none", "flex", "flex"]} isInline spacing={4}>
    <Button
      textTransform="uppercase"
      size="md"
      cursor="pointer"
      fontWeight={ currentSection === "orders" ? "bold" : "normal"}
      bg={ currentSection === "orders" ? "primary.100" : "none"}
      _focus={{ outline: "none" }}
      _hover={{
        bg: "primary.100",
        color:"primary.700",
        fontWeight:"bold"
      }}
      color={ currentSection === "orders" ? "primary.600" : "primary.100"}
      onClick={()=>setCurrentSection("orders")}
    >
      Orders
    </Button>
    <Button
      textTransform="uppercase"
      size="md"
      cursor="pointer"
      fontWeight={ currentSection === "customers" ? "bold" : "normal"}
      bg={ currentSection === "customers" ? "primary.100" : "none"}
      _focus={{ outline: "none" }}
      _hover={{
        bg: "primary.100",
        color:"primary.700",
        fontWeight:"bold"
      }}
      color={ currentSection === "customers" ? "primary.600" : "primary.100"}
      onClick={()=>setCurrentSection("customers")}
    >
      Customers
    </Button>
    <Button
      textTransform="uppercase"
      size="md"
      cursor="pointer"
      fontWeight={ currentSection === "payouts" ? "bold" : "normal"}
      bg={ currentSection === "payouts" ? "primary.100" : "none"}
      _focus={{ outline: "none" }}
      _hover={{
        bg: "primary.100",
        color:"primary.700",
        fontWeight:"bold"
      }}
      color={ currentSection === "payouts" ? "primary.600" : "primary.100"}
      onClick={()=>setCurrentSection("payouts")}
    >
      Payouts
    </Button>
  </Stack>
  )
}

export default MainDashboardMenu;